import {
  scheduleTime,
  scheduleTimeForFirstStep,
  immediateDelay,
} from '@/constants/outreach-delay-time';

/**
 * Resolve an outreach step's delay option by its stored interval value.
 *
 * Relocated here from `src/pages/mco/steps/components/step/delay.js` so
 * cross-feature consumers (the shared step view) can use it without importing
 * into the mco page layer. The original module re-exports this for
 * within-feature callers.
 */
export const getDelayById = (stepInterval) => {
  const delay = [
    ...scheduleTime,
    ...scheduleTimeForFirstStep,
    ...immediateDelay,
  ];
  return delay.find((time) => time.value === stepInterval);
};
